import React from 'react';

import { useAppContext } from 'hooks/useContext';
import { ResizableColumnsContainer, ColumnContainer } from './styles';

// Split children into multiple columns that can be resized
export default function ResizableColumns({ children, sizes }) {
  const { isDarkMode } = useAppContext();
  const splitSizes = sizes || Array(children.length).fill(100 / children.length);

  return (
    <ResizableColumnsContainer
      onDrag={() => window.dispatchEvent(new Event('resize'))}
      sizes={splitSizes}
      minSize={100}
      expandToMin={false}
      gutterSize={5}
      gutterAlign="center"
      snapOffset={30}
      dragInterval={1}
      direction="horizontal"
      cursor="col-resize"
      splitdarkmode={isDarkMode ? 'true' : undefined}
    >
      {children && children.map((child, index) => <ColumnContainer key={index}>{child}</ColumnContainer>)}
    </ResizableColumnsContainer>
  );
}
